/* ==========================================================
   Maison Velma — copie resserree des sections « en detail »
   ==========================================================
   Les textes d'origine faisaient 50 a 70 mots par carte. A cet
   endroit de la fiche le visiteur scanne, il ne lit pas : on
   garde chaque fait, on supprime la mise en scene.

   Regles appliquees aux 31 fiches :
   - le fait d'abord, la justification ensuite, jamais l'inverse ;
   - un fait par phrase, deux phrases par carte au maximum ;
   - suppression des « c'est ce qui », « au total », « si vous
     etes du genre a » : une ligne de plus, zero information ;
   - titres de cartes ramenes a un groupe nominal court ;
   - aucun fait supprime : ce qui ne tient pas ici est repris
     dans le tableau technique et la FAQ, juste dessous.

   La cle est le handle produit. Une fiche absente de la liste
   garde son texte d'origine, tronque a trois lignes
   (voir mv-fixes-2.css).

   Les lots 2 a 6 sont charges ci-dessous : ils appellent tous
   Object.assign sur le meme objet, l'ordre n'a donc pas
   d'importance. snippets/mv-ugc.liquid applique le tout, avec
   plusieurs passes, ce qui couvre un chargement tardif.
   ========================================================== */

window.MV_COPY = Object.assign(window.MV_COPY || {}, {

  'beatrice-litiere-autonettoyante-a-ouverture-superieure-bio-radar-et-sterilisation-uv': {
    intro: 'Un bac classique se ramasse matin et soir. Béatrice trie toute seule après chaque passage : les déchets partent dans un tiroir fermé en bas, et la grille de sortie garde les grains dans le bac.',
    titles: [
      'L’entrée par le dessus',
      'Trois détections, pas une',
      'Deux barrières anti-odeurs',
      'Hublot et application'
    ],
    cards: [
      'Le chat entre par le haut et ressort par une grille qui retient les grains collés à ses pattes. C’est ce qui la sépare d’un tambour rond.',
      'Bio-radar, capteur de poids et infrarouge : dix capteurs anti-pincement. Le bio-radar voit un chat parfaitement immobile, là où un infrarouge seul ne voit rien.',
      'Tiroir hermétique pour isoler, lumière UV bleue pour stériliser entre deux passages. Compartiment à parfum intégré, activable ou non.',
      'Le hublot montre l’intérieur avant d’ouvrir. L’application donne l’historique des passages et déclenche un cycle à distance.'
    ]
  }

});

/* --- Chargement des lots suivants -------------------------
   On repart de l'URL de ce fichier pour construire celle des
   autres : pas de chemin CDN ecrit en dur. async = false
   preserve l'ordre d'execution.                              */
(function () {
  var here = document.currentScript && document.currentScript.src;
  if (!here) return;

  var base = here.split('?')[0].replace(/mv-copy\.js$/, '');
  if (base === here) return;

  ['mv-copy-2.js', 'mv-copy-3.js', 'mv-copy-4.js', 'mv-copy-5.js', 'mv-copy-6.js'].forEach(function (file) {
    var tag = document.createElement('script');
    tag.src = base + file;
    tag.async = false;
    document.head.appendChild(tag);
  });
})();